export enum ContentItemType {
  Short = 'short',
  Paragraph = 'paragraph',
  Media = 'media',
  URL = 'url',
  Section = 'section',
  SurveyText = 'survey_text',
  SurveyRating = 'survey_rating',
  SurveyMCQ = 'survey_multiple_choice',
  TrainingMCQ = 'training_multiple_choice',
  TrainingCheckbox = 'training_checkbox',
  LearningCheckbox = 'checkbox',
}

export interface ContentItemDataPost {
  type: ContentItemType
  index: number
  text?: string
  media?: string
  url?: string
  title?: string
  question?: string
  answers?: string[]
  label?: string
  checkbox_text?: string
  page?: string
}
